module.exports = __webpack_public_path__ + "img/liste-drucken.4ca882b8.svg";